import Vue from 'vue';
import VueRouter from 'vue-router';
import Utils from '../common/utils';
// import {isAuthPage} from 'js/config/menu-config';

Vue.use(VueRouter);

const initRouter = () => {
    const routerParam = {
        mode: 'history',
        routes: [
            {
                path: '/',
                name: 'courseList',
                meta: {title: '春雨树在线课程'},
                component: (resolve) => require(['components/course/courseList'], resolve)
            },
            {
                path: '/course',
                name: 'courseDetail',
                meta: {title: '课程详情'},
                component: (resolve) => require(['components/course/courseDetail'], resolve)
            },
            {
                path: '/askStart',
                name: 'askStart',
                meta: {title: '开始闯关'},
                component: (resolve) => require(['components/ask/start'], resolve)
            },
            {
                path: '/question',
                name: 'question',
                meta: {title: '闯关答题'},
                component: (resolve) => require(['components/ask/question'], resolve)
            },
            {
                path: '/answer',
                name: 'answer',
                meta: {title: '查看答案'},
                component: (resolve) => require(['components/ask/answer'], resolve)
            },
            {
                path: '/ask/result',
                name: 'askResult',
                meta: {title: '得分'},
                component: (resolve) => require(['components/ask/result'], resolve)
            },
            {
                path: '/author',
                name: 'author',
                meta: {title: '登录'},
                component: (resolve) => require(['components/login/author'], resolve)
            },
            {
                path: '/taskDetail',
                name: 'taskDetail',
                meta: {title: '作业详情'},
                component: (resolve) => require(['components/task/taskDetail'], resolve)
            },
            {
                path: '/404',
                name: 'imgTest',
                meta: {title: '404'},
                component: (resolve) => require(['components/task/imgTest'], resolve)
            },
            {
                path: '/addTask',
                name: 'addTask',
                meta: {title: '添加作业'},
                component: (resolve) => require(['components/task/addTask'], resolve)
            }
        ]
    };

    let router = new VueRouter(routerParam);
    // let isFirstRouter = true;

    router.beforeEach((to, from, next) => {
        // if (!isFirstRouter && !isAuthPage(to.name)) {
        //     next({name: 'PermissionError'});
        //     return;
        // }
        if (to.meta && to.meta.title) {
            document.title = to.meta.title;
        } else {
            document.title = '小雨点';
        }
        // isFirstRouter = false;


        if(to.path == '/404'){
            next();

            return;
        }
        //判断是否登录
        let currentUserToken = Utils.getLocal("currentUserToken");
        if(!currentUserToken || currentUserToken == 'undefined'){
            currentUserToken=to.query.currentUserToken;
        }
        if(!currentUserToken || currentUserToken == 'undefined'){
            // window.top.location = '/404'
        }


        next();
    });
    // router.afterEach(() => {
    //     document.documentElement.scrollTop = 0;
    //     document.body.scrollTop = 0;
    //     let layoutContent = document.querySelector('.h-layout-content');
    //     if (layoutContent) {
    //         layoutContent.scrollTop = 0;
    //     }
    // });
    return router;
};

export default initRouter;
